export type SchoolLunchBox = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  title: string;
  description?: string | null;
  isLunaBox: boolean;
  image?: string | null;
};
